var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeySkeleton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 512,
      width: 512
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.28 18.22c-21.24.154-43.79 7.987-63.56 23.03a32.506 32.506 0 0 0-8.47-1.906c-10.406-.905-21.097 3.164-28.125 11.812-8.964 11.03-9.41 26.375-2.22 37.844-19.66 41.305-13.464 86.867 16.157 110.938 22.238 18.072 52.514 20.727 82.376 9.187l5.03-1.938 4.22 3.407 46.562 37.812L201.844 228l-43.875-35.656 11.78-14.5 43.875 35.625 15.344-18.876-43.876-35.656 11.78-14.5 43.876 35.656 16.563-20.375-46.532-37.814-4.218-3.437.875-5.345c5.19-31.587-3.573-60.646-25.812-78.72-13.53-10.994-30.48-16.316-48.344-16.186zm-2.25 25.468 43.845 13.874L139.562 101l-24.25-7.656 15.72-49.656zM57.876 57.78c.548-.016 1.107.013 1.656.064 2.637.243 5.25 1.265 7.5 3.093 6 4.876 6.876 13.408 2 19.407-4.874 5.998-13.406 6.907-19.405 2.03-6-4.875-6.876-13.406-2-19.405 2.666-3.282 6.41-5.068 10.25-5.19zm56.906 59.75 55.376 11.564-32.72 40.25-22.655-51.813zM91.22 123l12.468 22.156-35.313 43.438-22.53-40.063L91.218 123zm155.03 80-21.97 27.03 125.157 101.69-24.593 30.25 17.562 14.28 19.875-24.47 14.5 11.783-19.874 24.468 13.25 10.783-16.687 20.53-38.126 44.47 14.187 12.156 32.595-38 19.25 8.03 22.906-28.188 14.5 11.782-41.092 50.562 18.187 14.78 61.406-75.56 15.44 12.562 21.967-27.032L246.25 203z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeySkeleton);
export default __webpack_public_path__ + "static/media/key_skeleton.1bdea1b9833e45629de021aa9bc155b1.svg";
export { ForwardRef as ReactComponent };